import { FetchReturnType, WindowInterface } from './Window';

export class WindowBrowser implements WindowInterface {
    async getBackendUrl() {
        const location = window.location;
        return `${location.protocol}//${location.host}`;
    }

    fetch<T>(url: string, init?: RequestInit): FetchReturnType<T> {
        return window.fetch(url, init) as FetchReturnType<T>;
    }
}
